function updateLiveDesignCategory(item_id, new_parent_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/programme-changes`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      item_id: `${item_id}`,
      new_parent_id: `${new_parent_id}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default updateLiveDesignCategory;
